///
/// EarthBrowser
///
/// Camera-dependent altitudes for the upper-air shells. The real heights
/// (5.5 km for 500 hPa, 11 km for the jet) are invisible against a 6371 km
/// globe from space, so each shell is lifted to a fraction of the camera
/// altitude, clamped between its true height and a ceiling, and settles
/// back to the true height as the camera descends. The two fractions keep
/// the shells in their real order (500 hPa below the jet) at every zoom.
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///

export interface ShellProfile {
	/** True height; the shell never drops below this */
	trueKm: number
	/** Exaggeration ceiling, reached from the default global view */
	maxKm: number
	/** Shell altitude as a fraction of camera altitude between the limits */
	fraction: number
}

export const cJetShell: ShellProfile = { trueKm: 11, maxKm: 300, fraction: 0.05 }
export const cHeight500Shell: ShellProfile = { trueKm: 5.5, maxKm: 150, fraction: 0.025 }

export function shellAltitudeKm(profile: ShellProfile, cameraAltitudeKm: number): number {
	return Math.min(profile.maxKm, Math.max(profile.trueKm, cameraAltitudeKm * profile.fraction))
}
